import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';

import {
  StyledGallery,
  StyledNumber,
  StyledArrowLeft,
  StyledArrowRight,
  StyledBoxTextGallery,
  StyledImg
} from './style';
import Image from '../Image';
import { onAnimation } from './animation';

const GalleryPager = ({ activePage, pagesNumber }) => (
  <StyledNumber className="pager" activePage>
    {activePage + 1}/{pagesNumber}
  </StyledNumber>
);

const GalleryPreviousButton = ({ ...props }) => (
  <StyledArrowLeft className="pager" {...props} />
);
const GalleryNextButton = ({ ...props }) => (
  <StyledArrowRight className="pager" {...props} />
);

const Galleries = ({
  home,
  onToggleFullSize,
  title,
  subtitle,
  author,
  src
}) => (
  <StyledGallery onMouseLeave={onAnimation} home={home}>
    <Carousel
      previousButton={GalleryPreviousButton}
      nextButton={GalleryNextButton}
      paginator={GalleryPager}
      autoPlayInterval={50}
    >
      {src.map(image => (
        <StyledImg key={image} onMouseEnter={e => onAnimation(e, home)}>
          <StyledBoxTextGallery
            className="box"
            title={title}
            paragraph={subtitle}
            author={author}
          />
          <Image
            path={image}
            defaultCrop={{ width: 1239, height: 697 }}
            onClick={onToggleFullSize}
          />
        </StyledImg>
      ))}
    </Carousel>
  </StyledGallery>
);

Galleries.propTypes = {
  home: PropTypes.bool,
  onToggleFullSize: PropTypes.func,
  src: PropTypes.arrayOf(PropTypes.string)
};

export default Galleries;
